<template>
  <div class="krs019">
    <ul>      
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.RoleManage.001","권한아이디")}}</dt>
          <dd>
            <div class="txt">
              {{ roleId }}
            </div>
          </dd>
        </dl>
      </li>      
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.RoleManage.002","권한명")}}</dt>
          <dd>
            <div v-show="roleNameState == 'VIEW'">
              <div class="txt" style="overflow: hidden; text-overflow: ellipsis;">{{ roleName }}</div>
              <button
                  type="button"
                  class="btn-primary-small"
                  @click="changeRoleNameState"
                  style="right: -110px"
              >{{$i18nUtil.trans("button.modify","수정")}}
              </button>
            </div>
            <div v-show="roleNameState == 'EDIT'">
              <div class="edit-box">
                <input
                  type="text"
                  v-model="roleName"
                />
              </div>
              <button
                type="button"
                class="btn-primary-small black"                
                style="right: -110px"
              >{{$i18nUtil.trans("button.modify","수정")}}
              </button>
            </div>
          </dd>
        </dl>
      </li>      
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.RoleManage.003","권한설명")}}</dt>
          <dd>
            <div v-show="descriptionState == 'VIEW'">
              <div class="txt" style="overflow: hidden; text-overflow: ellipsis;">{{ description }}</div>
              <button
                  type="button"
                  class="btn-primary-small"
                  @click="changeDescriptionState"
                  style="right: -110px"
              >{{$i18nUtil.trans("button.modify","수정")}}
              </button>
            </div>
            <div v-show="descriptionState == 'EDIT'">
              <div class="edit-box">
                <input
                  type="text"
                  v-model="description"
                />
              </div>
              <button
                type="button"
                class="btn-primary-small black"                
                style="right: -110px"
              >{{$i18nUtil.trans("button.modify","수정")}}
              </button>
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.RoleManage.007","사용여부")}}</dt>
          <dd>
            <div class="txt">
              {{ useYn ? $i18nUtil.trans("message.RoleManage.004","사용") : $i18nUtil.trans("message.RoleManage.005","미사용") }}
            </div>
          </dd>
        </dl>
      </li>            
    </ul>
    <button
      type="button"
      class="btn-primary-small black"
      @click="updateRole"
      style="float: right; margin-top: 10px;"
    >{{$i18nUtil.trans("button.save","저장")}}
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
  components: {
    Dialog,
  },
  props: {
    modalInfo: {
      type: Object,
    },
  },
  data() {
    return {      
      roleNameState: "VIEW",
      descriptionState: "VIEW",
      roleId: null,
      roleName: null,
      description: null,
      useYn: null,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },    
  created() {
    this.getRoleInfo();
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast", "showDialog"]),
    getRoleInfo() {
      let obj = this;
      
      let reqData = {};
      reqData.params = {
        roleId: this.modalInfo.roleId,
      };
      reqData.url = "/api/org/role/getRoleInfo";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.roleId = res.result.roleId;
            obj.roleName = res.result.roleName;
            obj.description = res.result.description;
            obj.useYn = res.result.useYn;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    //코드값 변경
    updateRole(e) {
      let obj = this;

      let reqData = {};
        reqData.params = {
          roleId: obj.roleId,
          roleName: obj.roleName,
          description: obj.description,          
        };
        reqData.url = "/api/org/role/updateRole";
        reqData.method = "post";

        //프로그레스바 시작
        this.showLoadingbar();
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            //프로그레스바 종료
            this.hideLoadingbar();
            if (res.errorCode) {
              console.log(res.errorCode);
            } else {
              obj.toastInfo.message = obj.$i18nUtil.trans("message.RoleManage.006","권한 정보가 변경되었습니다.");
              obj.showToast(obj.toastInfo);
              obj.$emit("updateRole");              
              obj.roleNameState = "VIEW";
              obj.descriptionState = "VIEW";
            }
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });           
    },        
    changeRoleNameState(e) {
      this.roleNameState = "EDIT";
    },
    changeDescriptionState(e) {
      this.descriptionState = "EDIT";
    },    
  },
};
</script>

<style scoped>
.edit-box > input {
  width: 90%;
}
.edit-box input {
  height: 21px;
  padding: 0 0 0 5px;
  line-height: 21px;
  color: #000;
  border: 0 none;
}
.krs019 > ul > li > dl > dd {
  padding: 2px;
}
.krs019 > ul > li > dl > dt {
  width: 150px;
}
.krs019 > ul > li:nth-child(1) > dl > dd {
  width: 900px;
}
.krs019 > ul > li:nth-child(2) > dl > dd {
  width: 900px;
}
.krs019 > ul > li:nth-child(3) > dl > dd {
  width: 900px;
}
.krs019 > ul > li:nth-child(4) > dl > dd {
  width: 900px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/RoleManage.vue